import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { DistributionChannelEditorData } from "../../state/DistributionChannels/EditorData";


const updateDistributionChannelEditorData: Reducer<DistributionChannelEditorData> = (state: DistributionChannelEditorData = new DistributionChannelEditorData(), action: Action<ActionType, DistributionChannelEditorData>) => {
  switch (action.type) {
    case ActionType.DISTRIBUTION_CHANNELS_EDITOR_DATA_RESET:
      return new DistributionChannelEditorData();
    case ActionType.DISTRIBUTION_CHANNELS_EDITOR_DATA_FETCHED:
      return { ...state, distributionChannelData: action.data };
    case ActionType.DISTRIBUTION_CHANNELS_EDITOR_DATA_COPIED:
      return { ...state, distributionChannelData: { ...action.data} };
    case ActionType.DISTRIBUTION_CHANNELS_EDITOR_DATA_UPDATED:
      return { ...state, distributionChannelData: { ...state.distributionChannelData, ...action.data } };
    case ActionType.DISTRIBUTION_CHANNELS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.DISTRIBUTION_CHANNELS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    default:
      return state;
  }
};

export default updateDistributionChannelEditorData;